'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 400px;\n  height: 50px;\n  padding: 10px;\n  padding-left: 50px;\n  border-radius: 5px;\n  background: ', ';\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 10000;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02);\n'], ['\n  width: 400px;\n  height: 50px;\n  padding: 10px;\n  padding-left: 50px;\n  border-radius: 5px;\n  background: ', ';\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 10000;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02);\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n  color: ', ';\n  font-size: 20px;\n  pointer-events: none;\n'], ['\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n  color: ', ';\n  font-size: 20px;\n  pointer-events: none;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: block;\n  background: transparent;\n  font-family: inherit;\n  border: none;\n  outline: none;\n  color: ', ';\n  font-size: 18px;\n'], ['\n  width: 100%;\n  height: 100%;\n  display: block;\n  background: transparent;\n  font-family: inherit;\n  border: none;\n  outline: none;\n  color: ', ';\n  font-size: 18px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, _colors.white);

var IconContainer = _styledComponents2.default.div(_templateObject2, _colors.darkGrey);

var Input = _styledComponents2.default.input(_templateObject3, _colors.black);

var Search = function Search(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange;
  return _react2.default.createElement(Container, null, _react2.default.createElement(IconContainer, null, _react2.default.createElement(_Icon2.default, {
    icon: 'search1'
  })), _react2.default.createElement(Input, {
    type: 'text',
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }));
};

Search.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};
exports.default = Search;